module.exports = __webpack_public_path__ + "static/img/RAPZ3_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPZ3_1.png
// module id = JMki
// module chunks = 0